import { Injectable, OnDestroy } from '@angular/core';
import { ApiService } from '@nrwl/common-lib';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

const CODEC_URL = '/monitor/MonitorManager/v1/codecs';

@Injectable()
export class CodecChoiceService implements OnDestroy {
  unsubscribe: Subject<void> = new Subject();
  apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadCodecOptions(callbackFn: (any) => any): void {
    this.apiService
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      .get$<any>(CODEC_URL, {})
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          callbackFn(response);
        },
        error => {
          callbackFn(error);
        },
        () => {}
      );
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
